import { render } from "./renewal-service.vue?vue&type=template&id=e9181e94&scoped=true&ts=true"
import script from "./renewal-service.vue?vue&type=script&lang=ts"
export * from "./renewal-service.vue?vue&type=script&lang=ts"

import "./renewal-service.vue?vue&type=style&index=0&id=e9181e94&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9181e94"]])

export default __exports__